// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zRP6","input":"styles_input__25x8c"};